/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Breadcrumbs from '@/components/AZCustomComponent/BreadcrumbSTARC';
import { formatBreadcrumbsForSTARC } from '@/utils/STARC/STARC';
import styles from './CMSBreadcrumbs.module.scss';
import { useMappedCategoryData } from '../../../api/mapCategoryData';

export function CMSBreadcrumbs() {
  const { data: categoryData } = useMappedCategoryData();
  const breadCrumbsList = categoryData?.breadCrumbsList;

  if (!breadCrumbsList) {
    return null;
  }

  return (
    <Breadcrumbs
      customClass={styles.breadcrumbs}
      data={formatBreadcrumbsForSTARC(breadCrumbsList)}
    />
  );
}
